/**
 * схема для таблиц
 * @property {array} tableSortStates - режимы сортировки
 */
let schemeTable = {
    tableSortStates: {
        0: {
            type: 'none',
            icon: 'fa-minus'
        },
        1: {
            type: 'increase',
            icon: 'fa-arrow-up'
        },
        2: {
            type: 'decrease',
            icon: 'fa-arrow-down'
        }
    }
};

export default schemeTable;